import { useDispatch } from 'react-redux';
import {
  setBrands,
  setUser,
  setCompanyUsers,
  addPermissionIsUser,
  setCompanyPermission,
  setAllPermission
} from "../actions/user";

import { superAdminSetCompanies } from '../actions/super-admin';

import { companyAdminSetUsers } from '../actions/company-admin';
import { setCatalogsTree } from '../actions/user';
import { all_permissionsRef, company_permissionsRef, tokenRef, url, user_permissionsRef } from 'api';

export const useLogout = () => {
  const dispatch = useDispatch();
  
  return () => {
    localStorage.removeItem(tokenRef);
    localStorage.removeItem(user_permissionsRef);
    localStorage.removeItem(company_permissionsRef);
    localStorage.removeItem(all_permissionsRef); 
    localStorage.removeItem('exporters');

    dispatch(setUser(null));
    dispatch(setBrands(null));
    dispatch(setCompanyUsers(null));
    dispatch(companyAdminSetUsers(null));
    dispatch(addPermissionIsUser([]));
    dispatch(setAllPermission([]))
    dispatch(setCompanyPermission([]))

    dispatch(setCatalogsTree(null))
    dispatch({
      type: 'SUPER_ADMIN_SET_ALL_COMPANIES_BRANDS',
      payload: null,
    });
    dispatch({
      type: 'SUPER_ADMIN_SET_COMPANIES',
      payload: null,
    });
    dispatch({
      type: 'SUPER_ADMIN_SET_ALL_COMPANIES_BRANDS',
      payload: null,
    });
    dispatch({
      type: 'SUPER_ADMIN_SET_ALL_USERS',
      payload: null,
    });
    dispatch(superAdminSetCompanies(null));
  };
};
